/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DevAutoCalcLogDto
 */
export interface DevAutoCalcLogDto {
    /**
     * 
     * @type {number}
     * @memberof DevAutoCalcLogDto
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof DevAutoCalcLogDto
     */
    runDate: Date;
    /**
     * 
     * @type {number}
     * @memberof DevAutoCalcLogDto
     */
    priceUnitId: number;
    /**
     * 
     * @type {number}
     * @memberof DevAutoCalcLogDto
     */
    productId: number;
    /**
     * 
     * @type {string}
     * @memberof DevAutoCalcLogDto
     */
    category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevAutoCalcLogDto
     */
    detail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevAutoCalcLogDto
     */
    reason: string;
}

/**
 * Check if a given object implements the DevAutoCalcLogDto interface.
 */
export function instanceOfDevAutoCalcLogDto(value: object): value is DevAutoCalcLogDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('runDate' in value) || value['runDate'] === undefined) return false;
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    if (!('productId' in value) || value['productId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function DevAutoCalcLogDtoFromJSON(json: any): DevAutoCalcLogDto {
    return DevAutoCalcLogDtoFromJSONTyped(json, false);
}

export function DevAutoCalcLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevAutoCalcLogDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'runDate': (new Date(json['runDate'])),
        'priceUnitId': json['priceUnitId'],
        'productId': json['productId'],
        'category': json['category'] == null ? undefined : json['category'],
        'detail': json['detail'] == null ? undefined : json['detail'],
        'reason': json['reason'],
    };
}

export function DevAutoCalcLogDtoToJSON(json: any): DevAutoCalcLogDto {
    return DevAutoCalcLogDtoToJSONTyped(json, false);
}

export function DevAutoCalcLogDtoToJSONTyped(value?: DevAutoCalcLogDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'runDate': ((value['runDate']).toISOString()),
        'priceUnitId': value['priceUnitId'],
        'productId': value['productId'],
        'category': value['category'],
        'detail': value['detail'],
        'reason': value['reason'],
    };
}

